import pic1 from './make4thon.png';
import pic2 from './cloudathon.jpg';
import pic3 from './nit.jpg';
import pic4 from './doceree.jpg'
import pic5 from './jp.jpg';

const prizes = [
    {
        id: 1,
        image: pic1,
        title: "Microsoft League Hacking Make4thon 2022",
        Desc: "Lead my team to win 1st place in the title track 'Mental Health'",
        Link: "https://drive.google.com/file/d/1DOBsCMsGJjVkufd5BhRLIBDnqkRj0Mic/view?usp=sharing",
        Video:"https://www.loom.com/share/cb24d1c0703046a3a20a57302cee8a99?sid=f9200b39-bf63-4f93-b871-99f6a4048e62"
    },
    {
        id: 2,
        image: pic2,
        title: " Google Developer Student Clubs CLOUD-A-THON 2022",
        Desc: "Won 1st Place with my team in the hackathon conducted by Google Developer Student Clubs CLOUD-A-THON 2022",
        Link: "https://drive.google.com/file/d/1CiDzqKboNd4B-jw7m6ppo44YmhS_LXPH/view?usp=sharing",
        Video:"https://www.youtube.com/watch?v=8BVNeJUq-vE&list=LL&index=4"
        
    },
    {
        id: 3,
        image: pic3,
        title: "NIT Durgapur Hackoverflow 6.0 2023",
        Desc: "Lead my team to win 1st Place in the hackathon conducted by NIT Durgapur",
        Link: "https://drive.google.com/file/d/1pYOhlJxU0Vd4z3nIZtm5-YRdyDGO9wXX/view?usp=sharing",
        Video:"https://youtu.be/qaKxXAlZUsM?si=c0ZTlgmKPFXRbDAp"
    },
    {
        id: 4,
        image: pic4,
        title: "Doceree ML Hackathon conducted by TechGig Code Gladiators 2023",
        Desc: "Won 3rd Place in the hackathon conducted by TechGig Code Gladiators 2023",
        Link: "https://drive.google.com/file/d/1k6WJCssAGm90pAbrjBFmp42tgeW-rUGk/view?usp=sharing",
        Video:"https://youtu.be/eJBsIKQ_t8Q?si=b-DxTXuJ9Zt2K1nu"
        
    },
    {
        id: 5,
        image: pic5,
        title: "JPMC Mentorship Training Program 2021-2023",
        Desc: "Selected from among 600 students, Won 3rd Place in the Internal hackathon conducted by JPMC Mentorship Training Program 2023",
        Link: "https://drive.google.com/file/d/18ffIpZGHCZt1EqseaYPA3njGha9bf0NE/view?usp=sharing",
        Video:"-"
       
    },
   
]
export default prizes;